<div class="pdf">
  <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
    <p>Loading document...</p>
  </div>

  <div *ngIf="errorMsg" class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
    <p class="text-danger">{{ errorMsg }}</p>
  </div>

  <div *ngIf="!isLoading && !errorMsg && !isPdf && !isDoc" class="img-wrap">
    <img [src]="pdfSrc" alt="Driver Document" />
  </div>

  <div *ngIf="!isLoading && !errorMsg && isDoc" class="doc-wrap">
    <div *ngIf="isDocx && docHtml" class="doc-content" [innerHTML]="docHtml"></div>
    <iframe *ngIf="isLegacyDoc || (isDocx && !docHtml)" [src]="fileSrc" width="100%" height="600px" style="border:0;"></iframe>
  </div>

  <div *ngIf="!isLoading && !errorMsg && isPdf" class="pdf-wrap">
    <pdf-viewer
      [src]="pdfSrc"
      [render-text]="true"
      [original-size]="false"
      [external-link-target]="'blank'">
    </pdf-viewer>
  </div>

  <div *ngIf="!isLoading && !errorMsg" class="d-flex align-items-center btn-absolute">
    <span class="material-icons" (click)="download()">
      file_download
    </span>
    <span class="material-icons" (click)="closeDialog()">
      close
    </span>
  </div>
</div>